import './SelectionSnackbar.scss'
import {Button, ButtonGroup, CircularProgress, Snackbar, Tooltip, Typography} from "@mui/material";
import type {MouseEventHandler} from "react";
import React, {useContext} from "react";
import {observer} from "mobx-react-lite";
import {useStores} from "../../../../../stores";
import {Check, Close, Edit, Warning} from "@mui/icons-material";
import {CategoryMenuControllerContext} from "../../../context/CategoryMenuController";
import {plural} from "../../../../../utils/js-utils";
import {PART_NAME, SUPPLIER_NAME} from "./SelectionMessages";
import {environment} from "../../../../../env.ts";
import type {PartialCategory, PartialValidCategory} from "../../../../../services/classes/Category.ts";

export const SelectionSnackbar: React.FC = observer(() => {
    const {categorizationReviewStore} = useStores()
    const controller = useContext(CategoryMenuControllerContext);
    const reviewPageController = categorizationReviewStore.reviewPageController;
    const reviewPageSelectionController = categorizationReviewStore.reviewPageController.reviewPageSelectionController;
    const tableController = categorizationReviewStore.reviewPageController.reviewPageTableController;

    const handleClose = () => reviewPageSelectionController.clearSelection();

    const handleEditCategory: MouseEventHandler<HTMLButtonElement> = event => {
        if (!controller) {
            console.error('No controller set');
            return;
        }
        const anchor = event.currentTarget;
        controller.setOnSelect(c => {
            const category: PartialCategory = {};
            c.data.labels.forEach((label, index) => category['l' + (index + 1).toString()] = label);
            tableController.onReviewSelectionCategory(category as PartialValidCategory)
        });
        controller.open(
            anchor,
            {vertical: 'top', horizontal: 'center'},
            {vertical: 'bottom', horizontal: 'center'},
            true,
        )
    }
    const handleAcceptCategory = () => tableController.onReviewSelectionCategory(null);

    const P = PART_NAME;
    const S = SUPPLIER_NAME;

    const txtHelp = '';
    const editHelp = reviewPageSelectionController.editCategoryAlertMessage.msg;
    const editWarning = reviewPageSelectionController.editCategoryAlertMessage.warning;
    const editDisabled = reviewPageSelectionController.editCategoryAlertMessage.disabled ?? false;
    const acceptHelp = reviewPageSelectionController.acceptCategoryAlertMessage.msg;
    const acceptWarning = reviewPageSelectionController.acceptCategoryAlertMessage.warning;
    const acceptDisabled = reviewPageSelectionController.acceptCategoryAlertMessage.disabled ?? false;

    return <Snackbar open={reviewPageSelectionController.hasSelection}
                     anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}>
        <div id="dark-selection-snackbar">
            <ButtonGroup variant="contained">

                <Button className="first" onClick={handleClose}>
                    <Close/>
                </Button>

                {environment.isTestReviewPage && <pre style={{background: 'black', color: 'white', maxWidth: '15em'}}>
                    isAllSelected: {'' + reviewPageSelectionController.isAllSelected}<br/>
                    {/*nParts: {'' + reviewPageSelectionController.totalCountController.initNumberOfPartsCount}<br/>*/}
                    {/*resp: {'' + JSON.stringify(reviewPageSelectionController.totalCountController.muiDataGridAggregate.result)}<br/>*/}
                    nSuppliers: {'' + reviewPageSelectionController.totalCountController.initNumberOfSuppliersCount}<br/>
                    sel: s={'' + JSON.stringify(reviewPageSelectionController.selection.singleSelectedRows.length)}
                    {' '}fg={'' + JSON.stringify(reviewPageSelectionController.selection.fullSelectedGroups.length)}
                    {' '}g={'' + JSON.stringify(reviewPageSelectionController.selection.allGroupValues.size)}<br/>
                    <br/>
                </pre>}

                <Tooltip title={txtHelp} placement="top" arrow>
                    <div className="button-group-text"
                         style={{minWidth: reviewPageController.isGroupBy ? '27em' : '17em'}}>
                        {reviewPageSelectionController.selectionIsLoading && <CircularProgress size=".75rem"/>}
                        <Typography variant="body2">
                            {reviewPageController.isGroupBy ? <>
                                {!reviewPageSelectionController.selectionIsLoading && <>
                                    <span className="highlight">
                                        {reviewPageSelectionController.numberOfSuppliersSelected}
                                    </span>
                                    {` ${plural(S, reviewPageSelectionController.numberOfSuppliersSelected)}`}
                                    {' ('}
                                    <span className="highlight">
                                        {reviewPageSelectionController.numberOfPartsSelected}
                                    </span>
                                    {` ${plural(P, reviewPageSelectionController.totalSuppliers)}`}
                                    {') selected'}
                                </>}
                            </> : <>
                                <span className="highlight">
                                    {reviewPageSelectionController.numberOfPartsSelected}
                                </span>{' of '}
                                <span className="highlight">
                                    {reviewPageSelectionController.totalParts}
                                </span> selected
                            </>}
                        </Typography>
                    </div>
                </Tooltip>

                <Tooltip title={editHelp} placement="top" arrow>
                    <div className="grouped-tooltip-root">
                        <Button
                            className="border-left"
                            style={{minWidth: '19em'}}
                            onClick={handleEditCategory}
                            disabled={editDisabled}
                            startIcon={<Edit/>}
                            endIcon={editWarning ? <Warning/> : undefined}>
                            Change Category
                        </Button>
                    </div>
                </Tooltip>

                <Tooltip title={acceptHelp} placement="top" arrow>
                    <div className="grouped-tooltip-root">
                        <Button
                            className="last border-left"
                            style={{minWidth: '19em'}}
                            onClick={handleAcceptCategory}
                            disabled={acceptDisabled}
                            startIcon={<Check/>}
                            endIcon={acceptWarning ? <Warning/> : undefined}>
                            Accept Suggestion
                        </Button>
                    </div>
                </Tooltip>
            </ButtonGroup>
        </div>
    </Snackbar>
})
